// this mixin need inside every vue file which represents a view page

export default {
    data(){
        return{
            
        }
    }, 
    mounted(){
        this.checkToken()
    },
    watch:{
        $route(){
            this.checkToken()
        }
    },
    methods:{        
        checkToken(){
            //this function check the token is still valid
            let _this = this

            if (localStorage.getItem('ebus_token')) {
              _this.$store.state.token = localStorage.getItem('ebus_token');
            }

            _this.get('checktoken',
                {},
                async function(resp){                
                    //console.log('checktoken', _this.$route.name, resp)  
                                 
                    _this.$store.state.user = resp.data.user;                                                            
                    await _this.get('user/'+_this.$store.state.user.id,{params: {
                        relations: 1
                    }},function(resp2){
                        console.log(resp.data.user)
                        _this.$store.state.user = resp2.data.user[0]
                        _this.$store.state.user.main_payment_cluster = resp.data.user.main_payment_cluster
                    })                
                    // in the views the user ready function will run if the token is valid, so the user is logged in succesfull                
                    if (_this.userReady && _this.$store.state.user.status.toLowerCase() === 'active')
                    _this.userReady();
                  
                },function(){
                    //the token is invalid
                    //console.log('invalid token', resp)
                    localStorage.removeItem('ebus_token');
                    _this.$store.state.token = null
                    _this.$router.push({name: 'LogIn'})
                }
            )
        }
    
    }
}